import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userData: JSON.parse(localStorage.getItem("userData")) || null,
  isAuthenticated: !!localStorage.getItem("userData"),
  allowedRoutes: JSON.parse(localStorage.getItem("allowedRoutes")) || [],
};

const userSlice = createSlice({
  name: "users",
  initialState,
  reducers: {
    setUserData: (state, action) => {
      state.userData = action.payload;
      state.isAuthenticated = true;
      localStorage.setItem("userData", JSON.stringify(action.payload));
    },
    setAllowedRoutes: (state, action) => {
      state.allowedRoutes = action.payload;
      localStorage.setItem("allowedRoutes", JSON.stringify(action.payload));
    },
    logout: (state) => {
      state.userData = null;
      state.isAuthenticated = false;
      state.allowedRoutes = [];
      localStorage.removeItem("userData");
      localStorage.removeItem("allowedRoutes");
    },
  },
});

export const { setUserData, setAllowedRoutes, logout } = userSlice.actions;
export default userSlice.reducer;
